"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ATTACHMENT_ROOTS () {
        return ATTACHMENT_ROOTS;
    },
    get constructFilePath () {
        return constructFilePath;
    },
    get getFileNameFromUrl () {
        return getFileNameFromUrl;
    },
    get getPathFromUrl () {
        return getPathFromUrl;
    },
    get imageMimeTypes () {
        return imageMimeTypes;
    },
    get isPreviewAllowed () {
        return isPreviewAllowed;
    },
    get localFileExists () {
        return localFileExists;
    },
    get validateAndNormaliseLocalPath () {
        return validateAndNormaliseLocalPath;
    },
    get validateNumberOfFilesInCell () {
        return validateNumberOfFilesInCell;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _lite = /*#__PURE__*/ _interop_require_default(require("mime/lite"));
const _slash = /*#__PURE__*/ _interop_require_default(require("slash"));
const _nocodbsdk = require("nocodb-sdk");
const _nanoid = require("nanoid");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _objecthash = /*#__PURE__*/ _interop_require_default(require("object-hash"));
const _utils = require("~/utils");
const _ncconfig = require("~/utils/nc-config");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const imageMimeTypes = [
    'image/aces',
    'image/apng',
    'image/avci',
    'image/avcs',
    'image/avif',
    'image/bmp',
    'image/cgm',
    'image/dicom-rle',
    'image/dpx',
    'image/emf',
    'image/example',
    'image/fits',
    'image/g3fax',
    'image/gif',
    'image/heic',
    'image/heic-sequence',
    'image/heif',
    'image/heif-sequence',
    'image/hej2k',
    'image/hsj2',
    'image/ief',
    'image/j2c',
    'image/jaii',
    'image/jais',
    'image/jls',
    'image/jp2',
    'image/jpeg',
    'image/jph',
    'image/jphc',
    'image/jpm',
    'image/jpx',
    'image/jxl',
    'image/jxr',
    'image/jxrA',
    'image/jxrS',
    'image/jxs',
    'image/jxsc',
    'image/jxsi',
    'image/jxss',
    'image/ktx',
    'image/ktx2',
    'image/naplps',
    'image/png',
    'image/prs.btif',
    'image/prs.pti',
    'image/pwg-raster',
    // 'image/svg+xml', // risk of xss
    'image/t38',
    'image/tiff',
    'image/tiff-fx',
    // All vnd.* types usually not natively supported
    // 'image/vnd.adobe.photoshop',
    // 'image/vnd.airzip.accelerator.azv',
    // 'image/vnd.blockfact.facti',
    // 'image/vnd.clip',
    // 'image/vnd.cns.inf2',
    // 'image/vnd.dece.graphic',
    // 'image/vnd.djvu',
    // 'image/vnd.dwg',
    // 'image/vnd.dxf',
    // 'image/vnd.dvb.subtitle',
    // 'image/vnd.fastbidsheet',
    // 'image/vnd.fpx',
    // 'image/vnd.fst',
    // 'image/vnd.fujixerox.edmics-mmr',
    // 'image/vnd.fujixerox.edmics-rlc',
    // 'image/vnd.globalgraphics.pgb',
    // 'image/vnd.microsoft.icon',
    // 'image/vnd.mix',
    // 'image/vnd.ms-modi',
    // 'image/vnd.mozilla.apng',
    // 'image/vnd.net-fpx',
    // 'image/vnd.pco.b16',
    // 'image/vnd.radiance',
    // 'image/vnd.sealed.png',
    // 'image/vnd.sealedmedia.softseal.gif',
    // 'image/vnd.sealedmedia.softseal.jpg',
    // 'image/vnd.svf',
    // 'image/vnd.tencent.tap',
    // 'image/vnd.valve.source.texture',
    // 'image/vnd.wap.wbmp',
    // 'image/vnd.xiff',
    // 'image/vnd.zbrush.pcx',
    'image/webp',
    'image/wmf',
    'image/x-emf',
    'image/x-wmf'
];
const previewableMimeTypes = [
    ...imageMimeTypes,
    'pdf',
    'video',
    'audio'
];
function isPreviewAllowed(args) {
    const { mimetype, path } = args;
    if (mimetype) {
        return previewableMimeTypes.some((type)=>mimetype.includes(type));
    } else if (path) {
        const ext = path.split('.').pop();
        // clear query params
        const extWithoutQuery = ext == null ? void 0 : ext.split('?')[0];
        if (extWithoutQuery) {
            const mimeType = _lite.default.getType(extWithoutQuery);
            return previewableMimeTypes.some((type)=>mimeType == null ? void 0 : mimeType.includes(type));
        }
    }
    return false;
}
function validateAndNormaliseLocalPath(fileOrFolderPath, throw404 = false) {
    fileOrFolderPath = (0, _slash.default)(fileOrFolderPath);
    const toolDir = (0, _ncconfig.getToolDir)();
    // Get the absolute path to the base directory
    const absoluteBasePath = _path.default.resolve(toolDir, 'nc');
    // Get the absolute path to the file
    const absolutePath = _path.default.resolve(_path.default.join(toolDir, ...fileOrFolderPath.replace(toolDir, '').split('/')));
    // Check if the resolved path is within the intended directory
    if (!absolutePath.startsWith(absoluteBasePath)) {
        if (throw404) {
            _catchError.NcError.notFound();
        } else {
            _catchError.NcError.badRequest('Invalid path');
        }
    }
    return absolutePath;
}
function getPathFromUrl(url, removePrefix = false) {
    const newUrl = new URL(encodeURI(url));
    const pathName = removePrefix ? newUrl.pathname.replace(/.*?nc\/uploads\//, '') : newUrl.pathname;
    return decodeURI(`${pathName}${newUrl.search}${newUrl.hash}`);
}
const localFileExists = (path)=>{
    return _fs.default.promises.access(path).then(()=>true).catch(()=>false);
};
const ATTACHMENT_ROOTS = [
    'thumbnails',
    _nocodbsdk.PublicAttachmentScope.WORKSPACEPICS,
    _nocodbsdk.PublicAttachmentScope.PROFILEPICS,
    _nocodbsdk.PublicAttachmentScope.ORGANIZATIONPICS
];
const validateNumberOfFilesInCell = async (_context, _number, _column)=>{};
// ref: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html - extended with some more characters
const normalizeFilename = (filename)=>{
    return filename.replace(/[\\/:*?"<>'`#|%~{}[\]^]/g, '_');
};
const getFileNameFromUrl = (param)=>{
    var _param_url_split_pop;
    const originalFileName = ((_param_url_split_pop = param.url.split('/').pop()) == null ? void 0 : _param_url_split_pop.split('?')[0]) || 'attachment';
    const fileName = param.scope ? `${normalizeFilename(_path.default.parse(originalFileName).name)}${_path.default.extname(originalFileName)}` : `${normalizeFilename(_path.default.parse(originalFileName).name)}_${(0, _nanoid.nanoid)(5)}${_path.default.extname(originalFileName)}`;
    return {
        originalFileName,
        fileName
    };
};
const constructFilePath = (context, param)=>{
    var _param_scope;
    let filePath = _path.default.join(...[
        // somehow, even in production gui upload doesn't use workspace id
        'noco',
        context.base_id,
        param.modelId,
        param.columnId,
        param.scope ? (0, _nanoid.nanoid)(5) : undefined
    ].filter((k)=>k));
    if (param.scope) {
        filePath = (0, _objecthash.default)(context.user.id);
    } else if (_utils.isSecureAttachmentEnabled) {
        filePath = `${(0, _dayjs.default)().format('YYYY/MM/DD')}/${(0, _objecthash.default)(context.user.id)}`;
    }
    const destPath = _path.default.join(...[
        'nc',
        (_param_scope = param.scope) != null ? _param_scope : 'uploads',
        filePath
    ]);
    return {
        workspaceId: context.workspace_id,
        baseId: context.base_id,
        modelId: param.modelId,
        columnId: param.columnId,
        scope: param.scope,
        filePath,
        destPath,
        fileName: param.fileName,
        originalFileName: param.originalFileName,
        storageDest: (0, _slash.default)(_path.default.join(destPath, param.fileName))
    };
};
